// extracted by mini-css-extract-plugin
export default {"view":"container_view__vWlma"};